import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSeen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.00151 9.52823C8.39568 9.52823 9.52734 8.39656 9.52734 7.0024C9.52734 5.60823 8.39568 4.47656 7.00151 4.47656C5.60734 4.47656 4.47568 5.60823 4.47568 7.0024C4.47568 8.39656 5.60734 9.52823 7.00151 9.52823ZM7.00151 5.35156C7.91151 5.35156 8.65234 6.0924 8.65234 7.0024C8.65234 7.9124 7.91151 8.65323 7.00151 8.65323C6.09151 8.65323 5.35068 7.9124 5.35068 7.0024C5.35068 6.0924 6.09151 5.35156 7.00151 5.35156Z",
		fill: "#787878"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.00109 12.2655C9.19443 12.2655 11.2653 10.9822 12.6886 8.75385C13.3069 7.79135 13.3069 6.22219 12.6886 5.25385C11.2594 3.02552 9.18859 1.74219 7.00109 1.74219C4.81359 1.74219 2.74276 3.02552 1.31943 5.25385C0.701093 6.21635 0.701093 7.78552 1.31943 8.75385C2.74276 10.9822 4.81359 12.2655 7.00109 12.2655ZM7.00109 2.61719C8.88526 2.61719 10.6878 3.74885 11.9478 5.72635C12.3853 6.40885 12.3853 7.59885 11.9478 8.28135C10.6878 10.2589 8.88526 11.3905 7.00109 11.3905C5.11693 11.3905 3.31443 10.2589 2.05443 8.28135C1.61693 7.59885 1.61693 6.40885 2.05443 5.72635C3.31443 3.74885 5.11693 2.61719 7.00109 2.61719Z",
		fill: "#787878"
	})]
});
export default SvgSeen;
